import { render, staticRenderFns } from "./SupaStaticPage.vue?vue&type=template&id=34896b56&scoped=true&"
import script from "./SupaStaticPage.vue?vue&type=script&lang=js&"
export * from "./SupaStaticPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34896b56",
  null
  
)

export default component.exports